import React from 'react';

import {getModelPaperLink, SCIENTIFIC_MODEL} from 'model-hub/scientific-models/ScientificModelConstants';

export function AlphaFoldPaperLink(): JSX.Element {
  return (
    <a href={getModelPaperLink(SCIENTIFIC_MODEL.ALPHAFOLD)} target="_blank" rel="noopener noreferrer">
      AlphaFold2
    </a>
  );
}
